import { useTranslation } from "react-i18next";

import { Label, Message, Segment } from "semantic-ui-react";
import styled from "styled-components";

import type { OpenAPI } from "simplydo/interfaces";

import util from "utils/utils";

export const StyledSegment = styled(Segment)`
  ${({ $isAssessment }) =>
    $isAssessment ?
      `
    border: none !important;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${util.adjustColour("#6435c9", -0.08)} !important;
    h3 {
      margin: 0;
      padding: 0;
    }
  `
    : ""}
  ${({ $isPreview }) =>
    $isPreview ?
      `
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
  `
    : ""}
`;

type SectionHeaderProps = {
  section: OpenAPI.Schemas["IdeaTemplate"]["body"][number];
  isPreview?: boolean;
  assessment?: OpenAPI.Schemas["Idea"]["assessments"][number];
  canViewEdi: boolean;
  canEdit: boolean;
  isAuthor: boolean;
};

const SectionHeader = ({
  section,
  isPreview,
  assessment,
  canViewEdi,
  canEdit,
  isAuthor,
}: SectionHeaderProps) => {
  const { t } = useTranslation();

  return (
    <StyledSegment
      attached="top"
      $isPreview={isPreview}
      $isAssessment={section.type === "assessment"}
    >
      <h3>{section.name}</h3>
      {section.type === "assessment" ?
        <Label
          active
          color={
            (
              section.fields.filter(
                (field) =>
                  assessment?.assessment?.[field.id]?.score !== undefined &&
                  assessment?.assessment?.[field.id]?.score !== "",
              ).length ===
              section.fields.filter((field) => field.type === "assessment")
                .length
            ) ?
              "green"
            : undefined
          }
        >
          Assessed{" "}
          {
            section.fields.filter(
              (field) =>
                assessment?.assessment?.[field.id]?.score !== undefined &&
                assessment?.assessment?.[field.id]?.score !== "",
            ).length
          }{" "}
          /{" "}
          {section.fields.filter((field) => field.type === "assessment").length}
        </Label>
      : null}

      {section.type === "edi" ?
        !isAuthor && !canViewEdi && canEdit ?
          <Message warning>
            <Message.Header>EDI privacy notice</Message.Header>
            <Message.Content>
              {t("ideas.edi.header")}. Its content is hidden because you do not
              have permissions to view or edit the information in this section.
              For privacy reasons, only {t("generic.idea")} authors and
              administrators can see this data. If you believe you should have
              access, please contact your organisation's administrator.
            </Message.Content>
          </Message>
        : <Message success>
            <Message.Header>{t("ideas.edi.header")}</Message.Header>
            <Message.Content>{t("ideas.edi.info")}</Message.Content>
          </Message>

      : null}
    </StyledSegment>
  );
};

export default SectionHeader;
